import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../store/auth/authActions';
import Logo from '../../assets/app/logo.png'
import { FiHome, FiUsers, FiCalendar, FiFolder, FiCreditCard, FiSliders, FiLogOut, FiMenu, FiX, FiHeadphones, FiBell, FiEye, FiMail } from 'react-icons/fi';
import { getImage } from '../../utils';

import { MenuItem } from './menuItem';
import { AnimatePresence, motion } from 'framer-motion';
import { fetchInAppUnreadCount } from '../../store/notification/notificationActions';

const NavbarAdmin = () => {
	const dispatch = useDispatch();
	const { user } = useSelector((state) => state.auth);
	const [menuOpen, setMenuOpen] = useState(false);
	const [logoutOpen, setLogoutOpen] = useState(false);
	const cancelLogoutRef = useRef(null);

	const closeLogoutConfirm = () => setLogoutOpen(false);

	const confirmLogout = () => {
		closeLogoutConfirm();
		dispatch(logoutUser());
	};

	useEffect(() => {
		if (!logoutOpen) return;
		const onKeyDown = (e) => {
			if (e.key === 'Escape') closeLogoutConfirm();
		};
		document.addEventListener('keydown', onKeyDown);
		const prevOverflow = document.body.style.overflow;
		document.body.style.overflow = 'hidden';
		cancelLogoutRef.current?.focus();
		return () => {
			document.removeEventListener('keydown', onKeyDown);
			document.body.style.overflow = prevOverflow;
		};
	}, [logoutOpen]);

	const { support, inAppUnreadCount } = useSelector(state => state.notification)

	useEffect(() => {
		dispatch(fetchInAppUnreadCount());
	}, [dispatch]);


	return (

		<AnimatePresence>
			<>
				<div className='fixed md:hidden bg-white w-full flex z-50 justify-center items-center py-2'>
					<div className='md:hidden'>
						<button onClick={() => setMenuOpen((old) => !old)} className='absolute left-2 top-2 p-2 rounded-full bg-nt-blue text-white grid place-items-center shadow-md'>
							{!menuOpen ? <FiMenu size={24} /> : <FiX size={24} />}
						</button>
					</div>
					<img src={Logo} className='self-center justify-self-center' />

				</div>
				<div className={`w-[300px] overflow-y-auto h-[calc(100%-3.5rem)] md:min-h-screen rounded-tr-3xl rounded-br-3xl flex flex-col bg-white 
				items-start p-6 z-50 fixed transition-transform top-14 md:top-0
			${menuOpen ? "translate-x-0" : " -translate-x-full"} md:translate-x-0`}>
					<img src={Logo} className='hidden md:block mb-5 max-w-[120px]' />
					<div className={'w-full flex-1'}>
						<ul className='space-y-3'>
							<li>
								<MenuItem menuOpen={() => setMenuOpen(false)} title="Dashboard" Icon={FiHome} link='/' />
							</li>
							<li>
								<MenuItem menuOpen={() => setMenuOpen(false)} title="Users" link={'/users/list'} Icon={FiUsers} />
							</li>
							<li>
								<MenuItem menuOpen={() => setMenuOpen(false)} title="Administrators" link={'/users/administrators'} Icon={FiUsers} />
							</li>
							<li>
								<MenuItem menuOpen={() => setMenuOpen(false)} title="Moderation" link={'/users/moderation'} Icon={FiUsers} />
							</li>
							<li>
								<MenuItem menuOpen={() => setMenuOpen(false)} title="Rebrand email" link='/users/rebrand-announcement' Icon={FiMail} />
							</li>
							<li>
								<MenuItem menuOpen={() => setMenuOpen(false)} title="Appointments" Icon={FiCalendar} link='/admin/appointment' />
							</li>
							{/* <li>
								<MenuItem menuOpen={() => setMenuOpen(false)} title="Chat" Icon={FiMessageSquare} link='/chat' />
								</li> */}
							<li>
								<MenuItem menuOpen={() => setMenuOpen(false)} title="Support" Icon={FiHeadphones} link='/admin/support' notification={support} />
							</li>
							<li>
								<MenuItem menuOpen={() => setMenuOpen(false)} title="User chats" Icon={FiEye} link='/admin/user-conversations' />
							</li>
							<li>
								<MenuItem menuOpen={() => setMenuOpen(false)} title="Withdraw" Icon={FiFolder} link='/withdraw' />
							</li>
							<li>
								<MenuItem menuOpen={() => setMenuOpen(false)} title="Wallet" Icon={FiCreditCard} link='/wallet' />
							</li>
							<li>
								<MenuItem menuOpen={() => setMenuOpen(false)} title="Settings" Icon={FiSliders} link='/settings' />
							</li>
							<li>
								<MenuItem menuOpen={() => setMenuOpen(false)} title="Notifications" Icon={FiBell} link='/notifications' notification={inAppUnreadCount} />
							</li>
						</ul>
					</div>
					<div className={'flex gap-2 items-center justify-between text-sm w-full border-t-2 border-nt-grey-light pt-2'}>

						<img src={getImage(user?.avatar, "AVATAR")} className='w-12 rounded-full' />
						<div className={'flex flex-col grow'}>
							<div className={'text-nt-blue font-semibold capitalize'}>{user.firstName + ' ' + user.lastName}</div>
							<div className={'text-nt-grey'}>Admin</div>
						</div>
						<button
							type="button"
							onClick={() => setLogoutOpen(true)}
							className="w-8 h-8 grid place-items-center rounded-lg text-nt-blue hover:bg-nt-grey-light/60 focus:outline-none focus-visible:ring-2 focus-visible:ring-nt-blue focus-visible:ring-offset-2 transition-colors"
							aria-haspopup="dialog"
							aria-expanded={logoutOpen}
							aria-label="Sign out"
						>
							<FiLogOut className="shrink-0" size={22} aria-hidden />
						</button>
					</div>


				</div>

				<AnimatePresence>
					{logoutOpen && (
						<div className="fixed inset-0 z-[100] flex items-center justify-center p-4" role="presentation">
							<motion.div
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								exit={{ opacity: 0 }}
								transition={{ duration: 0.2 }}
								className="absolute inset-0 bg-black/45 backdrop-blur-[2px] cursor-default"
								onClick={closeLogoutConfirm}
								aria-hidden
							/>
							<motion.div
								role="dialog"
								aria-modal="true"
								aria-labelledby="logout-dialog-title"
								aria-describedby="logout-dialog-desc"
								initial={{ opacity: 0, scale: 0.96, y: 8 }}
								animate={{ opacity: 1, scale: 1, y: 0 }}
								exit={{ opacity: 0, scale: 0.96, y: 8 }}
								transition={{ type: 'spring', stiffness: 380, damping: 28 }}
								className="relative w-full max-w-[400px] rounded-2xl bg-white shadow-2xl shadow-black/15 ring-1 ring-black/5 overflow-hidden"
							>
								<div className="p-6 sm:p-8">
									<div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-nt-blue/10 text-nt-blue">
										<FiLogOut size={26} strokeWidth={2} aria-hidden />
									</div>
									<h2 id="logout-dialog-title" className="text-center text-lg font-semibold text-nt-blue sm:text-xl">
										Sign out?
									</h2>
									<div className="mt-8 flex flex-col-reverse gap-3 sm:flex-row sm:justify-center">
										<button
											ref={cancelLogoutRef}
											type="button"
											onClick={closeLogoutConfirm}
											className="w-full sm:w-auto min-h-[44px] rounded-xl border-2 border-nt-grey-light px-5 py-2.5 text-sm font-semibold text-nt-blue hover:bg-nt-grey-light/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-nt-blue focus-visible:ring-offset-2 transition-colors sm:min-w-[120px]"
										>
											Stay signed in
										</button>
										<button
											type="button"
											onClick={confirmLogout}
											className="w-full sm:w-auto min-h-[44px] rounded-xl bg-nt-red px-5 py-2.5 text-sm font-semibold text-white hover:opacity-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-nt-red focus-visible:ring-offset-2 transition-opacity sm:min-w-[120px]"
										>
											Sign out
										</button>
									</div>
								</div>
							</motion.div>
						</div>
					)}
				</AnimatePresence>
			</>
		</AnimatePresence>
	);
};




export { NavbarAdmin };

